import { useEffect, useState } from "react";
import { useResponsive } from "../../../../hooks";
import { standardMeasurementData, Measurement } from "./types";
import { DesktopView } from "./desktop";
import { MobileView } from "./mobile";

export function RoofMeasurementTable(props: { measurements: any; setMeasurements?: any }) {
    const { measurements, setMeasurements } = props;
    const [data, setData] = useState(standardMeasurementData);
    const { isMobile } = useResponsive();

    const processedData = () => {
        if (!measurements || measurements.length === 0) {
            return;
        }
        const newData = standardMeasurementData.map((item: any) => {
            const entry = measurements.find((entry: any) => entry.MeasurementType === item.name);
            if (!entry) {
                return item;
            }
            return {
                ...item,
                name: entry.MeasurementType,
                total: entry.CalculatedValue,
                actual: entry.ActualValue,
                id: entry.Id,
            };
        });

        setData(newData);
    };

    const handleEdit = (event: { id: string; actual: number }) => {
        const { id, actual } = event;
        setMeasurements((prev: Measurement[]) => prev.map((m) => (m.Id === id ? { ...m, ActualValue: actual } : m)));
    };

    useEffect(() => {
        processedData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [measurements]);

    if (isMobile) {
        return <MobileView data={data} handleEdit={handleEdit} />;
    }

    return <DesktopView data={data} handleEdit={handleEdit} />;
}
